<template>
  <BaseEditModal
    displayName="Create Panel"
    helpFileName="CreatePanelModal"
    :tabs="tabs"
    :icon="'mdi-table-large-plus'"
    @close="emit('close')"
    :masterObj="panelToEdit"
    :saveFunc="saveItem"
    :deleteFunc="deleteItem"
    :instanceDeletable="props.panel"
    @locked="(bool) => emit('locked', bool)"
    @activeTab="handleTabChange"></BaseEditModal>
</template>
<script setup>
import CreatePanel from './CreatePanel.vue';
import BaseEditModal from '../Shared/Modals/BaseEditModal.vue';
import { $http } from '../../stores/http.js';
const props = defineProps(['index', 'panel']);
const emit = defineEmits(['close', 'locked']);

var panelToEdit = {
  name: '',
  description: '',
  available_slots: 25,
  icon: '',
  color: '',
};
if (props.panel) {
  panelToEdit = JSON.parse(JSON.stringify(props.panel));
}
const tabs = [
  {
    id: 0,
    title: 'Create Panel',
    icon: 'mdi-text-box-search-outline',
    display: true,
    component: CreatePanel,
  },
];
async function saveItem(uid, data) {
  if (props.panel) {
    try {
      await $http('PUT', `/update_panel`, JSON.stringify(data));
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      await $http('POST', `/create_panel`, JSON.stringify(data));
    } catch (error) {
      console.log(error);
    }
    emit('close');
  }
}
async function deleteItem() {
  try {
    await $http('DELETE', `/delete_panel?panel_uid=${props.panel.uid}`);
    emit('close');
  } catch (error) {
    console.log(error);
  }
}
</script>
